// extracted by mini-css-extract-plugin
module.exports = {"root":"AnswerScale_root__20wbE","options":"AnswerScale_options__1PIRH","selected":"AnswerScale_selected__2KTGM"};